import styled from "styled-components";
import FilterButtons from "Components/Fragment/FilterButtons";

export const StyledFilterButtons = styled(FilterButtons)`
  margin-left: 24px;
`;

export const StyledProgram = styled.div`
  padding: 0 0 48px 0;
  max-width: 1100px;

  .card-course-icon {
    position: absolute;
    top: 5px;
    left: 5px;
  }

  .card-dates span {
    font-size: 14px;
  }

  .managerSelect__menu {
    z-index: 10 !important;
  }
`;

export const StyledSurveyLinkContainer = styled.div`
  margin-top: 25px;
`;
